import Sorter from './components/Sorter'

function App() {
  return (
    <div>
      <Sorter />
    </div>
  );
}

export default App;
